<template lang="pug">
  .contenedor-interno
    .title
      span Reporte de permisos
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)

          .filtros(v-if="mostrarFiltros", key="filtros")
            .filtro
              .title-singular
                p Tipo
              .select.display-flex
                select.flex-1(v-model='filtroTipo')
                  option(value="all") Todos
                  option(:value="+o.codigo", v-for="(o, key) in tipos") {{ o.descripcion }}

            .filtro
              .codigo-empleado
                .control.title-singular
                  p Código de empleado
                  .input-container
                    input.input(
                      type="number",
                      v-model="filtroCodigoEmpleado"
                      @focus="mostrarBusquedaEmpleado = true"
                    )
                    span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                      i.fa.fa-search
                    .erase-data(@click="filtroCodigoEmpleado = ''")
                      .icon
                        .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaEmpleado"
                    )
                      lookup-small-empleado(
                        @selected="seleccionarEmpleado"
                        @close="mostrarBusquedaEmpleado = false"
                        :codigo="filtroCodigoEmpleado"
                      )

            .filtro
              .title-singular
                p Desde
              .select.display-flex
                input.input(
                  type="date",
                  v-model="filtroMes",
                  @blur="fetch"
                )
            .filtro
              .title-singular
                p Hasta
              .select.display-flex
                input.input(
                  type="date",
                  v-model="filtroYear",
                  @blur="fetch"
                )
          .boton-container(key="boton-container")
            button.button(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar
            button.button.margin-button-top(@click="exportarExcel")
              span.icon.is-small
                i.fa.fa-file-excel-o.fa-fw.fa-lg
              span Exportar Excel
            button.button.margin-button-top(@click="exportarNuevoExcel")
              span.icon.is-small
                i.fa.fa-file-excel-o.fa-fw.fa-lg
              span Exportar Nuevo reporte
      .body(key="body")
        .is-loading(v-if="isLoading")
          .icon
            i.fa.fa-spinner.fa-spin
        .information(v-else)
          template(v-if="solicitudes.length !== 0")
            .is-desktop
              table.table.is-striped.is-bordered
                thead
                  th Empleado
                  th Tipo
                  th Motivo
                  th Adjunto
                tbody(
                  name="table-row"
                  is="transition-group"
                )
                  tr.row-table(
                    v-for="(o,index) in solicitudes"
                    :key="o+index+''"
                  )
                    td.text-center
                      .hint--top(:aria-label="'Empleado: ' + o.codigoEmpleado")
                        .hint--bottom(:aria-label="'Solicitud: ' + o.idSolicitud")
                          span.hint--right(:aria-label="'ID: ' + o.id")
                            | {{ o.nombreEmpleado }}
                    td {{ o.descripcionTipo }}
                    td
                      template(v-if="o.motivo")
                        span {{ o.motivo }}
                      template(v-else)
                        span Sin motivo
                      br
                      .dias-pedidos
                        strong Fecha
                        div
                          span.detalle-dias {{ o.fecha }} {{ o.horaDesde }}-{{ o.horaHasta }}
                    td.text-center
                      template(v-if="o.adjunto")
                        a.button.is-small(:href="o.adjunto", target="_blank")
                          span.icon.is-small
                            i.fa.fa-paperclip.is-small.fs-12
                          span Ver adjunto
                      template(v-else)
                        span Sin adjunto
            .is-mobile
              .box(
                v-for="(o, index) in solicitudes"
                :key="o+index+''"
              )
                .descripcion-tipo.hint--top(:aria-label="'Empleado: ' + o.codigoEmpleado")
                  .hint--bottom(:aria-label="'Solicitud: ' + o.idSolicitud")
                    span.is-bold.hint--right(:aria-label="'ID: ' + o.id")
                      | {{ o.nombreEmpleado }}
                .descripcion-tipo
                  span {{ o.descripcionTipo }}
                .motivo
                  div
                    template(v-if="o.motivo")
                      span {{ o.motivo }}
                    template(v-else)
                      span Sin motivo
                .dias-pedidos
                  strong Fecha
                  div
                    span.detalle-dias {{ o.fecha }} {{ o.horaDesde }}-{{ o.horaHasta }}
                .botones
                  template(v-if="o.adjunto")
                    a.button.is-small(:href="o.adjunto", target="_blank")
                      span.icon.is-small
                            i.fa.fa-paperclip.is-small.fs-12
                      span Ver adjunto
          div(v-else)
            .message.is-warning
              .message-body No hay permisos que cumplan con los siguientes filtros
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import { apiGet, apiGetExcel, notify } from '../util/general'
import moment from 'moment'
export default {
  name: 'reporte_permisos_component',
  data () {
    return {
      solicitudes                 : [],
      isLoading                   : false,
      mostrarBusquedaEmpleado     : false,
      mostrarFiltros              : true,
      mostrarConfirmacionNoLoTomo : false,
      solicitudSeleccionada       : {},
      filtroCodigoEmpleado        : '',
      filtroMes                   : moment().startOf('month').format('YYYY-MM-DD'),
      filtroYear                  : moment().endOf('month').format('YYYY-MM-DD'),
      filtroTipo                  : 'all',
      meses                : [
        { codigo: 1, descripcion: 'Enero' },
        { codigo: 2, descripcion: 'Febrero' },
        { codigo: 3, descripcion: 'Marzo' },
        { codigo: 4, descripcion: 'Abril' },
        { codigo: 5, descripcion: 'Mayo' },
        { codigo: 6, descripcion: 'Junio' },
        { codigo: 7, descripcion: 'Julio' },
        { codigo: 8, descripcion: 'Agosto' },
        { codigo: 9, descripcion: 'Setiembre' },
        { codigo: 10, descripcion: 'Octubre' },
        { codigo: 11, descripcion: 'Noviembre' },
        { codigo: 12, descripcion: 'Diciembre' }
      ],
      years: [
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ],
      tipos                       : []
    }
  },
  components: {
    LookupSmallEmpleado
  },
  created () {
    this.fetchTipos()
    this.fetch()
  },
  watch : {
    filtroCodigoEmpleado (value) {
      return this.fetch()
    },
    filtroTipo (value) {
      return this.fetch()
    }
  },
  methods: {
    fetchTipos () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/permisos/tipo', obj, function (data) {
        vm.tipos = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true

      var filtros = {
        codigoEmpleado : vm.filtroCodigoEmpleado,
        tipo           : vm.filtroTipo,
        desde            : vm.filtroMes,
        hasta           : vm.filtroYear
      }
      apiGet(vm, '/permisos/reporte', { filtros }, function (data) {
        vm.solicitudes = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtroCodigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtroTipo           = 'all'
      this.filtroCodigoEmpleado = ''
      this.filtroMes            = moment().startOf('month').format('YYYY-MM-DD')
      this.filtroYear           = moment().endOf('month').format('YYYY-MM-DD')
    },
    exportarExcel () {
      var vm = this
      vm.isLoading = true

      var filtros = {
        codigoEmpleado : vm.filtroCodigoEmpleado,
        tipo           : vm.filtroTipo,
        desde            : vm.filtroMes,
        hasta           : vm.filtroYear
      }

      apiGetExcel(vm, '/permisos/reporte/excel', {filtros}, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'permisos' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    exportarNuevoExcel () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var filtros = {
        codigoEmpleado : vm.filtroCodigoEmpleado,
        tipo           : vm.filtroTipo,
        desde            : vm.filtroMes,
        hasta           : vm.filtroYear
      }
      apiGetExcel(vm, '/permisos/reporte/excelNuevo', {filtros}, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'reporteVacacionesEmpleado' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .is-bold
    font-weight bold
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px




  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;
  .dias-pedidos
    font-size 12px
    color #9a9a9a

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  @media(max-width: 1080px)
    .filtros
      flex-direction: column;
      .filtro
        width 100%;
  @media (max-width 560px)
    .is-mobile
      display block

    .is-desktop
      display none

  @media (max-width 399px)
    .boton-container
      .margin-button-top
        margin-top 5px

</style>



// WEBPACK FOOTER //
// Component_Permisos_Reporte.vue?b383bbb6